import './App.css';
import {
	BrowserRouter,
	Navigate,
	Outlet,
	Route,
	Routes,
	useLocation,
} from 'react-router-dom';
import { getAccessToken, getUserRole } from './Utils/AuthUtil';
import Conversations from './pages/Conversations/Conversations';
import Login from './pages/Login';
import ChatHistoryList from './pages/ChatHistoryList';
import AgentRequests from './pages/AgentRequests';
import KnowledgeUpload from './pages/KnowledgeUploads/KnowledgeUpload';
import CreateAccount from './pages/CreateAccount';
import GuestLandingPage from './pages/GuestLandingPage';
import { ToastAlert } from './components/ToastAlert';
import AgencyAdmins from './pages/SuperAdmin/AgencyAdmins';
import SessionGuard from './components/SessionGuard';
import StatsDashboard from './pages/SuperAdmin/StatsDashboard';
import CustomerClientAssignment from './pages/SuperAdmin/CustomerClientAssignment';

function App() {
	return (
		<>
			<BrowserRouter>
				<SessionGuard />
				<Routes>
					<Route element={<AuthenticationRoutes />}>
						<Route
							path="/"
							element={<Navigate to="/home" replace />}
						/>
						<Route path="/login" element={<Login />} />
						<Route
							path="/createAccount"
							element={<CreateAccount />}
						/>
						<Route path="/home" element={<GuestLandingPage />} />
					</Route>
					<Route element={<SuperAdminRoutes />}>
						<Route path="/admins" element={<AgencyAdmins />} />
						<Route path="/stat" element={<StatsDashboard />} />
						<Route
							path="/customerClientAssignment"
							element={<CustomerClientAssignment />}
						/>
					</Route>
					<Route element={<PrivateRoutes />}>
						<Route path="/chats" element={<Conversations />} />
						<Route
							path="/chatHistory"
							element={<ChatHistoryList />}
						/>
						<Route
							path="/agentRequest"
							element={<AgentRequests />}
						/>
						<Route
							path="/knowledgeUpload"
							element={<KnowledgeUpload />}
						/>
					</Route>
				</Routes>
			</BrowserRouter>
			<ToastAlert />
		</>
	);
}

function PrivateRoutes() {
	return getAccessToken() && parseInt(getUserRole()) === 100 ? (
		<Outlet />
	) : (
		<Navigate to="/home" />
	);
}

function SuperAdminRoutes() {
	return getAccessToken() && parseInt(getUserRole()) === 1000 ? (
		<Outlet />
	) : (
		<Navigate to="/login" />
	);
}

function AdminRoutes() {
	return getAccessToken() && parseInt(getUserRole()) === 100 ? (
		<Outlet />
	) : (
		<Navigate to="/login" />
	);
}

function AuthenticationRoutes() {
	const location = useLocation();
	const path = location.pathname;
	const userRole = parseInt(getUserRole());
	const alwaysPublicPaths = ['/home', '/reset/role'];
	const isAlwaysPublic = alwaysPublicPaths.some(route =>
		path.startsWith(route),
	);

	if (isAlwaysPublic && userRole !== 1000) {
		return <Outlet />;
	}

	if (getAccessToken()) {
		if (userRole === 1000) {
			return <Navigate to="/admins" />;
		}

		if (userRole === 100) {
			return <Navigate to="/home" />;
		}

		// if (userRole === 101 || userRole === 102) {
		// 	return <Navigate to="/chats" />;
		// }

		return <Outlet />;
	}

	return <Outlet />;
}

export default App;
